import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import WebsiteBrandPillar from "@/models/WebsiteBrandPillar/WebsiteBrandPillar";
import WebsitePage from "@/models/WebsitePage/WebsitePage";

export default class WebsiteBrandPillarPage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-brand-pillar-page';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteBrandPillarPages';

    static fields() {
        return {
            id:this.number(null).nullable(),
            user_id: this.number(null).nullable(),
            website_brand_pillar_id: this.number(null).nullable(),
            website_page_id: this.number(null).nullable(),
            websiteBrandPillar: this.belongsTo(WebsiteBrandPillar, 'website_brand_pillar_id'),
            user: this.belongsTo(User, 'user_id'),
            websitePage: this.belongsTo(WebsitePage, 'website_page_id'),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    Url() {
        const websitePage = this.WebsitePage();

        if (websitePage && websitePage.url) {
            return '/website-pages/' + websitePage.url;
        }

        // Fallback when no related page or slug is available
        return '/website-pages';
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    WebsiteUrl() {
        return window.config.WEBSITE_URL + this.Url();
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    User() {
        return this.getRelated('user');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsiteBrandPillar() {
        return this.getRelated('websiteBrandPillar');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WebsitePage() {
        return this.getRelated('websitePage');
    }
}
